export const setTextFilter = (text = '') => ({
  type: 'SET_INCOME_TEXT_FILTER',
  text
});

export const sortByAmount = () => ({
  type: 'SORT_INCOME_BY_AMOUNT'
});

export const sortByDate = () => ({
  type: 'SORT_INCOME_BY_DATE'
});

export const setStartDate = (date) => ({
  type: 'SET_INCOME_START_DATE',
  date
});

export const setEndDate = (date) => ({
  type: 'SET_INCOME_END_DATE',
  date
});